export const PUBLIC_ARTICLES_URL = `${process.env.REACT_APP_API_URL}/articles`;
export const PUBLIC_COURSES_URL = `${process.env.REACT_APP_API_URL}/courses`;
export const PUBLIC_NEWS_URL = `${process.env.REACT_APP_API_URL}/news`;
export const PUBLIC_PAGES_URL = `${process.env.REACT_APP_API_URL}/pages`;
export const PUBLIC_POPUPS_URL = `${process.env.REACT_APP_API_URL}/popups`;
export const PUBLIC_FARMS_URL = `${process.env.REACT_APP_API_URL}/farms`;
export const PUBLIC_FIELDS_URL = `${process.env.REACT_APP_API_URL}/fields`;
export const PUBLIC_REDZONES_URL = `${process.env.REACT_APP_API_URL}/redzones`;
export const PUBLIC_METHODS_URL = `${process.env.REACT_APP_API_URL}/methods`;
export const PUBLIC_MODULES_URL = `${process.env.REACT_APP_API_URL}/modules`;
export const PUBLIC_VERIFICATIONS_URL = `${process.env.REACT_APP_API_URL}/verifications`;
export const PUBLIC_USER_URL = `${process.env.REACT_APP_API_URL}/user`;
export const PUBLIC_CROP_EXPLORER_URL = `${process.env.REACT_APP_API_URL}/crop-explorations`;
export const PUBLIC_DIGITAL_AGRONOMIST_URL = `${process.env.REACT_APP_API_URL}/digital-agronomist`;
export const PUBLIC_CARBON_PROGRAM_URL = `${process.env.REACT_APP_API_URL}/carbon-programs`;
export const PUBLIC_PRACTICES_URL = `${process.env.REACT_APP_API_URL}/practices`;
export const PUBLIC_DAIRY_URL = `${process.env.REACT_APP_API_URL}/dairy`;
export const PUBLIC_FOOTPRINTING_URL = `${process.env.REACT_APP_API_URL}/footprinting`;
